<template>
  <transition name="el-loading-fade" @after-leave="handleAfterLeave">
    <div
      v-show="visible"
      class="el-loading-mask"
      :style="{ backgroundColor: background || '', 'border-radius': '6px' }"
      :class="[customClass, { 'is-fullscreen': fullscreen }]">
      <div class="el-loading-spinner" style="margin-top: -62px">
        <p v-if="text1" class="el-loading-text" style="font-size: 2em; color: white">{{ text1 }}</p>
        <p v-if="text2" class="el-loading-text" style="font-size: 2em; color: white">{{ text2 }}</p>
        <button v-if="buttonText" style="margin-top: 20px" @click="$router.push(buttonUrl)" type="button" class="btn btn-wd btn-fill btn-lg"><i :class="buttonIcon" style="color: inherit"></i> {{buttonText}}</button>
        <svg v-else-if="!spinner" class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none"/>
        </svg>
        <i v-else :class="spinner"></i>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    data() {
      return {
        text1: null,
        text2: null,
        spinner: null,
        buttonText: null,
        buttonIcon: null,
        buttonUrl: null,
        background: null,
        fullscreen: true,
        visible: false,
        customClass: ''
      };
    },

    methods: {
      handleAfterLeave() {
        this.$emit('after-leave');
      },
      setText(text) {
        this.text = text;
      }
    }
  };
</script>
